import React from "react";
import { Flex, Text, Box, Image, VStack, Button } from "@chakra-ui/react";

import logo from "../../assets/logo.png";
import kidsImage from "../../assets/register-image-kids.png";

const AuthTermsAndConditions = () => {
  return (
    <Flex
      justify="center"
      align="center"
      height="100vh"
      marginTop={14}
      marginBottom={14}
      bg="white"
      position="relative"
    >
      {/* Left Image */}
      <Box
        flex={1}
        justifyContent="flex-end"
        alignItems="flex-end"
        display={"flex"}
      >
        <Image
          src={kidsImage}
          alt="Kids Fashion"
          objectFit="cover"
          width={589}
          height={440}
        />
      </Box>
      {/* Right Content */}
      <Box
        flex={1}
        justifyContent="center"
        alignItems="center"
        display={"flex"}
      >
        <VStack align="flex-center" spacing={6} width={580}>
          <Image src={logo} height={"110px"} />
          <Text
            fontFamily={"PlusJakartaSansMedium"}
            fontSize={"36px"}
            lineHeight={"38px"}
            color={"#000000"}
            textAlign={"center"}
          >
            Terms & Conditions
          </Text>

          <VStack align="flex-center" spacing={2}>
            <Text
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"24px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
              textTransform={"capitalize"}
              marginTop={4}
            >
              SELLER’S TERMS & CONDITIONS
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"14px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
            >
              Suspends aliquot interdorm deque, a dictum olio facilizes nec.
              Nula pharetra sagittal qualm a molestee. Sed dolor mauri's, locus
              id protium a, abaculis nec lectors. Suspends potent. In varies sem
              sed orca Bibendum locus. Cu abitur dictum sem felids, in tempus
              sapient interdorm nec.Suspends aliquot interdorm deque, a dictum
              olio facilizes nec. Nula pharetra sagittal qualm a molestee. Sed
              dolor mauri's, locus id protium a, abaculis nec lectors. Suspends
              potent. In varies sem sed orca Bibendum locus. Cu abitur dictum
              sem felids, in tempus sapient interdorm nec. Suspends aliquot
              interdorm deque, a dictum olio facilizes nec. Nula pharetra
              sagittal qualm a molestee. Sed dolor mauri's, locus id protium a,
              abaculis nec lectors. Suspends potent. In varies sem sed orca
              Bibendum locus. Cu abitur dictum sem felids, in tempus sapient
              interdorm nec.
            </Text>
            <Text
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"24px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
              textTransform={"capitalize"}
              marginTop={6}
            >
              REGISTRATION
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"14px"}
              lineHeight={"32px"}
              color={"#000000"}
              textAlign={"center"}
            >
              Suspends aliquot interdorm deque, a dictum olio facilizes nec.
              Nula pharetra sagittal
            </Text>
            <VStack alignItems={"flex-end"}>
              <Button
                bgColor={"#456EFF"}
                colorScheme="#456EFF"
                borderRadius={"12px"}
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"16px"}
                lineHeight={"20px"}
                color={"#FFFFFF"}
                // textAlign={"center"}
                w={"150px"}
                h={"48px"}
                marginTop={3}
                // onClick={() => formik.handleSubmit()}
                // isDisabled={isRegisterDisabled}
              >
                Next
              </Button>
            </VStack>
          </VStack>
        </VStack>
      </Box>
    </Flex>
  );
};

export default AuthTermsAndConditions;
